import "core-js/modules/esnext.global-this.js";
import "core-js/modules/esnext.global-this.js";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
/*! @carvana/microfrontend-plugins v1.1.0 - Tue Aug 01 2023 19:40:15 GMT+0000 (Coordinated Universal Time) */


var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var __publicField = function __publicField(obj, key, value) {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

  return value;
};

var isSSR = function isSSR() {
  return typeof window === "undefined" || /ServerSideRendering|SSR/i.test(window.navigator && window.navigator.userAgent);
};

var GlobalObjectWaiter = /*#__PURE__*/function () {
  function GlobalObjectWaiter(objectName, object, env, maxRetries, retryInterval) {
    var _this = this;

    if (object === void 0) {
      object = null;
    }

    if (maxRetries === void 0) {
      maxRetries = 3;
    }

    if (retryInterval === void 0) {
      retryInterval = 1e3;
    }

    __publicField(this, "object", null);

    __publicField(this, "objectName");

    __publicField(this, "maxRetries", 3);

    __publicField(this, "retryInterval", 1e3);

    __publicField(this, "queue", []);

    __publicField(this, "retries", 0);

    __publicField(this, "env");

    __publicField(this, "checkForObject", function () {
      try {
        return _this.object || globalThis[_this.objectName];
      } catch (error) {
        return null;
      }
    });

    this.objectName = objectName;
    this.object = object;
    this.maxRetries = maxRetries;
    this.retryInterval = retryInterval;
    this.env = env;

    if (!this.object) {
      this.waitForGlobalObject();
    }
  }

  var _proto = GlobalObjectWaiter.prototype;

  _proto.waitForGlobalObject = function waitForGlobalObject() {
    var _this2 = this;

    var tryGetObject = function tryGetObject() {
      var globalObject = _this2.checkForObject();

      if (globalObject) {
        _this2.object = globalObject;

        _this2.processQueue();
      } else if (_this2.retries < _this2.maxRetries) {
        _this2.retries++;
        setTimeout(tryGetObject, _this2.retryInterval);
      } else if (_this2.env !== "production") {
        console.error("Global object not found after maximum retries");
      }
    };

    tryGetObject();
  };

  _proto.processQueue = function processQueue() {
    while (this.queue.length > 0) {
      var action = this.queue.shift();

      if (action) {
        action(this.object);
      }
    }
  };

  _proto.exec = function exec(action) {
    if (this.object) {
      action(this.object);
    } else {
      this.queue.push(action);
    }
  };

  return GlobalObjectWaiter;
}();

var isLocalhost = function isLocalhost(url) {
  if (!url) return true;
  return ["localhost", "0.0.0.0"].find(function (x) {
    return url.indexOf(x) >= 0;
  });
};

var pageUrl = function pageUrl() {
  var originPageUrl = new URL(window.location.href) || {};
  return originPageUrl.origin + "/" + ((originPageUrl.pathname.split("/").filter(Boolean) || [])[0] || "");
};

var getUrls = function getUrls(_ref) {
  var url = _ref.url;

  var _a;

  if (!url) return {};
  var moduleURL = new URL(url) || {};
  var moduleFileName = (_a = moduleURL == null ? void 0 : moduleURL.pathname) == null ? void 0 : _a.split("/").pop();
  return {
    moduleURL: moduleURL,
    moduleFileName: moduleFileName,
    pageUrl: pageUrl()
  };
};

var pluginName = "analytics";
var pluginVersion = "1.0.0";

function extractNumber(input) {
  if (!input) return 0;
  var numberStr = "";
  var foundDecimal = false;

  for (var _iterator3 = _createForOfIteratorHelperLoose(input), _step3; !(_step3 = _iterator3()).done;) {
    var char = _step3.value;

    if (char >= "0" && char <= "9") {
      numberStr += char;
    } else if (char === "." && !foundDecimal) {
      numberStr += char;
      foundDecimal = true;
    } else if (numberStr.length > 0) {
      break;
    }
  }

  if (numberStr.length > 0) {
    var floatValue = parseFloat(numberStr);
    return Math.round(floatValue);
  } else {
    return 0;
  }
}

var AnalyticsPlugin = function AnalyticsPlugin(opts) {
  return function (_ref2) {
    var env = _ref2.env,
        id = _ref2.id,
        name = _ref2.name,
        version = _ref2.version,
        fncType = _ref2.fncType;

    var _b;

    if (isSSR()) return {};

    try {
      var _a = opts,
          _a$skipLocalhostUrl = _a.skipLocalhostUrl,
          skipLocalhostUrl = _a$skipLocalhostUrl === void 0 ? true : _a$skipLocalhostUrl,
          customDDR = _a.ddr,
          restOpts = __objRest(_a, ["skipLocalhostUrl", "ddr"]);

      var ddr = new GlobalObjectWaiter("DD_RUM", customDDR, env);
      (_b = ddr == null ? void 0 : ddr.exec) == null ? void 0 : _b.call(ddr, function (fn) {
        var _a2;

        (_a2 = fn == null ? void 0 : fn.init) == null ? void 0 : _a2.call(fn, {
          applicationId: "f9a4284c-171e-4cfa-8208-4fcb1549d8d8",
          clientToken: "pub2f9bf8bb53604c5f9e159b3eae06c7b6",
          site: "datadoghq.com",
          service: "core-mfer",
          env: env,
          sessionSampleRate: 100,
          sessionReplaySampleRate: 0,
          trackResources: false,
          trackLongTasks: false,
          trackUserInteractions: false,
          tracingSampleRate: env === "production" ? 20 : 100
        });
      });

      var onModuleLoaded = function onModuleLoaded(props) {
        var _b2;

        try {
          var _a2 = props,
              type = _a2.type,
              rest = __objRest(_a2, ["type"]);

          if (type === "module-loaded") {
            var _getUrls = getUrls(rest),
                moduleFileName = _getUrls.moduleFileName,
                moduleURL = _getUrls.moduleURL,
                pageUrl2 = _getUrls.pageUrl;

            var moduleName = rest.moduleName,
                moduleLoadTime = rest.moduleLoadTime;

            if (skipLocalhostUrl && isLocalhost(pageUrl2)) {
              return;
            }

            (_b2 = ddr == null ? void 0 : ddr.exec) == null ? void 0 : _b2.call(ddr, function (fn) {
              var _a3;

              (_a3 = fn == null ? void 0 : fn.addAction) == null ? void 0 : _a3.call(fn, "mfer-module-load", {
                service: "core-mfer",
                env: env,
                mfer: __spreadProps(__spreadValues({}, restOpts), {
                  shellName: name,
                  shellID: id,
                  version: version,
                  configType: fncType,
                  pageUrl: pageUrl2,
                  originalHref: window.location.href,
                  moduleName: moduleName,
                  moduleUrl: moduleURL == null ? void 0 : moduleURL.href,
                  moduleFileName: moduleFileName,
                  moduleLoadTime: moduleLoadTime,
                  moduleLoadTimeNum: extractNumber(moduleLoadTime)
                })
              });
            });
          }
        } catch (error) {}
      };

      var onStartEnd = function onStartEnd(actionName) {
        return function (props) {
          var _a2;

          try {
            var _ref3 = props || {},
                _ref3$time = _ref3.time,
                time = _ref3$time === void 0 ? 0 : _ref3$time;

            if (skipLocalhostUrl && isLocalhost(pageUrl())) {
              return;
            }

            (_a2 = ddr == null ? void 0 : ddr.exec) == null ? void 0 : _a2.call(ddr, function (fn) {
              var _a3;

              (_a3 = fn == null ? void 0 : fn.addAction) == null ? void 0 : _a3.call(fn, actionName, {
                service: "core-mfer",
                env: env,
                mfer: __spreadProps(__spreadValues({}, restOpts), {
                  shellName: name,
                  shellID: id,
                  version: version,
                  configType: fncType,
                  pageUrl: pageUrl(),
                  originalHref: window.location.href,
                  time: time,
                  timeNum: extractNumber(time)
                })
              });
            });
          } catch (error) {}
        };
      };

      return {
        name: pluginName,
        version: pluginVersion,
        runInSSR: false,
        onStart: onStartEnd("mfer-start"),
        onEnd: onStartEnd("mfer-end"),
        onError: onStartEnd("mfer-error"),
        onPreLoadHighPriorityFilesStart: onStartEnd("mfer-preload-high-priority-start"),
        onPreLoadHighPriorityFilesEnd: onStartEnd("mfer-preload-high-priority-end"),
        onPreLoadHighPriorityFilesError: onStartEnd("mfer-preload-high-priority-error"),
        onLoadChunksStart: onStartEnd("mfer-chunks-start"),
        onLoadChunksEnd: onStartEnd("mfer-chunks-end"),
        onLoadChunksError: onStartEnd("mfer-chunks-error"),
        onLoadCssStart: onStartEnd("mfer-css-start"),
        onLoadCssEnd: onStartEnd("mfer-css-end"),
        onLoadCssError: onStartEnd("mfer-css-error"),
        onLoadMainFilesStart: onStartEnd("mfer-module-start"),
        onLoadMainFilesEnd: onStartEnd("mfer-module-end"),
        onLoadMainFilesError: onStartEnd("mfer-module-error"),
        onLoadMainFilesMessage: onModuleLoaded
      };
    } catch (error) {
      return {
        name: pluginName,
        version: pluginVersion,
        runInSSR: false
      };
    }
  };
};

export { AnalyticsPlugin };